import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class ResetPasswordController extends Controller {
  @tracked token = '';

  queryParams = ['token'];
}
